import { render, staticRenderFns } from "./TabsAdvSelector.vue?vue&type=template&id=08df672f&scoped=true"
import script from "./TabsAdvSelector.vue?vue&type=script&lang=js"
export * from "./TabsAdvSelector.vue?vue&type=script&lang=js"
import style0 from "./TabsAdvSelector.vue?vue&type=style&index=0&id=08df672f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08df672f",
  null
  
)

export default component.exports